import slugify from 'slugify';

const afexSlugify = (string, config) => {
  if (!string) {
    return '';
  }

  return slugify(string, { lower: true });
};

export default afexSlugify;
